import ImageWrapper from "@/components/ImageWrapper";
import { TextToSlug } from "@/helpers/useCommonFunctions";
import { AemHost } from "@/utils/constant";
import { Box } from "@dxp-feed/ui/Box";
import { Card, CardHeader } from "@dxp-feed/ui/Card";
import { Text } from "@dxp-feed/ui/Text";
import Link from "@/components/Link";

const CategorieList = ({ aemCategorieData }: { aemCategorieData: any }) => {
  const recipesCategoriesList = aemCategorieData?.recipesCategoriesList;
  const categoriestitle = aemCategorieData?.categoriestitle;
  const renderCategoryCards = () =>
    recipesCategoriesList?.map((ele: any, index: number) => (
      <Link
        key={index + ele?.label}
        href={`/recipe-tag/${TextToSlug(ele?.label)}`}
        passHref
        className="h-full bg-brandWhite shadow-md rounded-lg overflow-hidden"
      >
        <Box as="div">
          <Card className="shadow-none">
            <Box
              as="div"
              className="relative bg-grey300 min-h-[126px] overflow-hidden pt-[75%] md:pt-[77%] xl:pt-[57%]"
            >
              <ImageWrapper
                src={AemHost + ele.image}
                alt={`Image for recipe category: ${ele?.label}`}
                fill
                className="absolute top-0 left-0 object-cover"
                fetchPriority="high"
              />
            </Box>
            <CardHeader className="border-none pt-2 pb-4 px-[18px]">
              <Text as="span" className="text-base font-bold text-grey950">
                {ele?.label}
              </Text>
            </CardHeader>
          </Card>
        </Box>
      </Link>
    ));

  return (
    <Box as="div" className="pb-6 md:pb-12 lg:pb-6">
      <Text as="h3" className="title-tertiary pb-6">
        {categoriestitle}
      </Text>
      <Box
        as="div"
        className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-4 lg:grid-cols-2 xl:grid-cols-4 gap-6 xl:gap-10 w-full"
      >
        {renderCategoryCards()}
      </Box>
    </Box>
  );
};

export default CategorieList;
